import ModelUtil from '@leverege/model-util'

const TYPE = 'condition.ObjectizerRule'
const EMPTY = {}

function create( options ) {
  const { name, value, condition } = options || EMPTY
  return {
    type : TYPE,
    name,
    condition,
    value
  }
}

export default { 
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'name' ),
  ...ModelUtil.createAllValue( 'condition' ),
  ...ModelUtil.createAllValue( 'value' )
}
